import React from 'react';
import autoBind from 'react-autobind';
import {formatString, formatAccountNumber} from '../../utils/Formatter';
import {ProductIds} from '../../constants/ApplicationConstants';

export default class PageHeading extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    getInvestorName(){
        let investorName = '';
        if (this.props.isSingleAccount && this.props.data && this.props.data.investorList && this.props.data.investorList.length > 0){
            investorName = ' ' + this.props.data.investorList[0].name;
        }
        return investorName;
    }

    readyForFundingH1(){
        return (<div id="cpCongratulationsHeader" key="readyForFundingH1"><h3>{formatString(this.props.content.readyForFundingPageHeading.line1, {investorName: this.getInvestorName()})}</h3><div id="cpProductAccount" key="readyForFundingH2">{formatString(this.props.content.readyForFundingPageHeading.line2, {product: this.props.product})}</div></div>)
    }

    readyForFundingH2(){
        return (<h3 id="cpProductAccountHeader" key="readyForFundingH2Header">{this.props.content.accountHeader}</h3>)
    }

    accountNumberAndOin(){
        let accountNumber = formatAccountNumber(this.props.data.accountNumber);
        let superFirstAccountNumber = formatAccountNumber(this.props.data.superFirstAccountNumber);
        let message;
        if (this.props.isSingleAccount){
            if (this.props.productCode === ProductIds.PENSION && this.props.data.superFirstAccountNumber.length !== 0) {
                message = formatString(this.props.content.superFirstAccountNumberPageHeading, {accountNumber: accountNumber, superFirstAccountNumber: superFirstAccountNumber, oin: this.props.data.investorList[0].oin});
            } else {
                message = formatString(this.props.content.accountNumberPageHeading, {accountNumber: accountNumber, oin: this.props.data.investorList[0].oin});
            }
            return (<div id="cpAccountNumberGroup" className="account-number" key="accountNumber" dangerouslySetInnerHTML={{__html: message}}></div>);
        }
        else{
            return (<div id="cpAccountNumberGroup" className="account-number" key="investorAccountNumber">
                <div id="cpAccountNumber">Account number:{accountNumber}</div>
                {this.props.data.investorList.map(function(investor, idx){
                    return (<div id={`cpInvestor${idx}`} key={`investor__${idx}`}>
                        <div id={`cpInvestorName${idx}`} key={`investorName__${idx}`}>{investor.name}</div>
                        <div id={`cpInvestorOin${idx}`} key={`investorOin__${idx}`}>Online Identity Number (OIN):{investor.oin}</div>
                    </div>);
                })}
            </div>);
        }
        
    }

    renderReadyForFundingHeading() {
        if (!this.props.content.readyForFundingPageHeading){
            return [];
        }
        return [this.readyForFundingH1, this.readyForFundingH2, this.accountNumberAndOin];
    }

    shellH1(){
        return (<div id="cpCongratulationsHeader" key="readyForFundingH1"><h3>{this.props.content.shellPageHeading.line1}</h3><div id="cpProductAccount" key="shellH2">{formatString(this.props.content.shellPageHeading.line2, {product: this.props.product})}</div></div>)
    }

    shellH2(){
        return (<h3 id="cpProductAccountHeader" key="shellH2Header">{this.props.content.accountHeader}</h3>);
    }

    renderShellAccountHeading() {
        if (!this.props.content.shellPageHeading){
            return [];
        }
        return [this.shellH1, this.shellH2, this.accountNumberAndOin];
    }

    render() {
        let elements = this.props.isShellAccount ? this.renderShellAccountHeading() : this.renderReadyForFundingHeading();
        return (
            <div className="container">
                {elements.map(function(el){
                    return el();
                })}
            </div>);
    }
}

PageHeading.propTypes = {
    isShellAccount: React.PropTypes.bool.isRequired,
    isSingleAccount: React.PropTypes.bool.isRequired,
    data: React.PropTypes.object.isRequired,
    product: React.PropTypes.string.isRequired,
    content: React.PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Congratulations/PageHeading.jsx